import {LotoCardboardRepository} from "../ports/LotoCardboardRepository";

export class DeleteLotoCardboard {
    constructor(private readonly repo: LotoCardboardRepository) {}

    async execute(id: string): Promise<void> {
        await this.repo.delete(id);
    }
}
